import { useEffect, useRef, useState } from "react";
import { useLocalization } from "@fluent/react";
import { Drawer, Tabs } from "@narmi/design_system";
import { useSetChatVisibility } from "cerulean";
import { useGetTemplateVersions } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates";
import VersionHistoryTab from "./VersionHistoryTab";

type VersionHistoryDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  templateUuid: API.BulkTemplateId;
  groupState: string;
  activeVersionId: API.BulkTemplateVersionId | null;
};

const VersionHistoryDrawer = ({
  isOpen,
  onClose,
  templateUuid,
  groupState,
  activeVersionId,
}: VersionHistoryDrawerProps) => {
  const drawerIdRef = useRef(
    `Drawer-${Math.random().toString(36).slice(2, 11)}`
  );
  useSetChatVisibility(drawerIdRef.current, !isOpen);
  const { l10n } = useLocalization();
  const { getTemplateVersions, loading: versionsLoading } =
    useGetTemplateVersions();
  const [versions, setVersions] = useState<API.BulkTemplateVersion[]>([]);

  useEffect(() => {
    if (isOpen && templateUuid) {
      getTemplateVersions(templateUuid, {
        onData: (data) => setVersions(data),
      });
    }
  }, [isOpen, templateUuid, getTemplateVersions]);

  return (
    <Drawer
      depth="524px"
      isOpen={isOpen}
      onUserDismiss={onClose}
      paddingSize="xl"
    >
      <Tabs defaultSelectedIndex={0}>
        <Tabs.List>
          <Tabs.Tab
            label={l10n.getString("tab-version-history")}
            tabId="version-history"
          />
        </Tabs.List>
        <Tabs.Panel tabId="version-history">
          <VersionHistoryTab
            templateUuid={templateUuid}
            groupState={groupState}
            activeVersionId={activeVersionId}
            versions={versions}
            versionsLoading={versionsLoading}
          />
        </Tabs.Panel>
      </Tabs>
    </Drawer>
  );
};

export default VersionHistoryDrawer;
